<template>
  <div>
    <!-- toolbar container, to prevent parent flexer shrinking children like hlines -->
    
    <!-- toolbar container, to prevent parent flexer shrinking children like hlines -->
    <div>
      <v-container pa-0 style="position: relative;">
        <!-- PC TOOLBAR -->
        <div v-if="!$vuetify.breakpoint.xs" class="pl-4 pr-4 pt-4">

          <v-breadcrumbs>
            <v-breadcrumbs-item to="/dashboard/">
              Home
            </v-breadcrumbs-item>
            <span class="pl-2 pr-2">/</span>
            <v-breadcrumbs-item disabled>
              Server statistics
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <v-layout align-center>
            <div class="headline font-weight-medium">
              Server statistics
            </div>
          </v-layout>

        </div>

        <!-- MOBILE toolbar -->
        <div v-if="$vuetify.breakpoint.xs">
          <v-layout align-center>
            <v-btn icon @click="drawer = !drawer">
              <v-icon>menu</v-icon>
            </v-btn>
            <v-flex class="text-ellipsed text-sans font-weight-bold">
              Server statistics
            </v-flex>
          </v-layout>
        </div>

      </v-container>

      <div class="c-hr"></div>

    </div>
    <!-- end toolbar container, to prevent parent flexer shrinking children linke hlines -->

    <!-- MAIN CONTENT -->
    <div>

      <v-container pa-0>
        <v-card class="ma-4 pa-2">
          <div class="title">
            MYSQL
          </div>
          <div v-for="statistic of Object.keys(json)" :key="statistic">
            <span>{{ statistic }}</span>: <span>{{ json[statistic] }}</span>
          </div>
          <v-layout>
            Load:&nbsp;
            <span class="font-weight-bold green--text">
              {{ healthPercent }}%
            </span>
          </v-layout>
        </v-card>

        <v-card class="ma-4 pa-2">
          <div class="title">
            Lets encrypt -- certbot
          </div>
          {{ letsEncrypt }}
        </v-card>
      </v-container>

    </div>
    <!-- END MAIN CONTENT -->

  </div>
</template>

<script>
export default {
  data () {
    return {
      json: {},
      letsEncrypt: ''
    }
  },
  computed: {
    healthPercent () {
      return ((this.json.allConnections - this.json.freeConnections) / this.json.connectionLimit) * 100
    }
  },
  methods: {
    getLetsEncrypt () {
      this.$axios.get('/server-stats/lets-encrypt')
      .then(response => {
        console.log('---------------')
        console.log(response)
        console.log(response.data)
        this.letsEncrypt = response.data
      })
      .catch(error => this.$root.$errorSnackbar(error))
    }
  },
  created () {
    console.log('sending')
    this.$axios.get('/server-stats/pool')
    .then(response => {
      this.json = response.data
      console.log(response.data)
    })
    .catch(error => this.$root.$errorSnackbar(error))

    this.getLetsEncrypt()
  }
}
</script>

